import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Suit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9.15a.25.25 0 1 1-.25.25m.25-.247a.25.25 0 0 0-.25.25M9.236 6.359 12 5.268l2.763 1.091c.674 0 .674-4 0-4L12 3.451 9.236 2.359c-.673 0-.673 4 0 4m.992 10.796L6.962 6.636a6.52 6.52 0 0 0-4.1 2.787.5.5 0 0 0 .2.737l2.264 1.064a.5.5 0 0 1 .238.669l-1.1 2.282a.5.5 0 0 0 .009.45l4.855 7.016a4.79 4.79 0 0 0 .9-4.486m4.438 4.486 4.855-7.016a.5.5 0 0 0 .009-.45l-1.1-2.282a.5.5 0 0 1 .238-.669l2.264-1.064a.5.5 0 0 0 .2-.737 6.52 6.52 0 0 0-4.1-2.787l-3.26 10.519a4.79 4.79 0 0 0 .894 4.486m-2.416-8a.25.25 0 1 0-.5 0 .25.25 0 0 0 .5 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Suit) as SvgIcon;
export { ForwardRef as ReactComponent };
